import { render, staticRenderFns } from "./modal-importar-historico.vue?vue&type=template&id=51997a5d&"
import script from "./modal-importar-historico.vue?vue&type=script&lang=js&"
export * from "./modal-importar-historico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51997a5d')) {
      api.createRecord('51997a5d', component.options)
    } else {
      api.reload('51997a5d', component.options)
    }
    module.hot.accept("./modal-importar-historico.vue?vue&type=template&id=51997a5d&", function () {
      api.rerender('51997a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/modal/modal-importar-historico/modal-importar-historico.vue"
export default component.exports